define('C3.ShoppingExtensions.HomeExt.View'
, 	[
		'c3_shoppingextensions_homeext.tpl',
		'Profile.Model',
		//'SC.Configuration',
		'Utils',
		'Backbone.View'
	],
function (
		c3_shoppingextensions_homeext_tpl,
		ProfileModel,
		//Configuration,
		Utils,
		BackboneView
){
	'use strict';
	return Backbone.View.extend({

		template: c3_shoppingextensions_homeext_tpl,

	    initSlider: function initSlider() {
	        Utils.initBxSlider(this.$('[data-slider1]'), {
	            nextText: '<a class="home-gallery-next-icon"></a>',
	            prevText: '<a class="home-gallery-prev-icon"></a>',
	            auto: true,
				responsive: true,
				pager: true,
				controls: true,
				touchEnabled: true,
				preventDefaultSwipeX: false,
				preventDefaultSwipeY: false
	        });
	    },
		initialize: function (options) {
			this.options = options;
			this.configuration = options.application.Configuration;

			this.windowWidth = jQuery(window).width();
        	this.options.application.getLayout().on('afterAppendView', this.initSlider, this);


			 const windowResizeHandler = _.throttle(function() {
	            if (
	                Utils.getDeviceType(this.windowWidth) ===
	                Utils.getDeviceType(jQuery(window).width())
	            ) {
	                return;
	            }
	            this.showContent();

	            Utils.resetViewportWidth();

	            this.windowWidth = jQuery(window).width();
	        }, 1000);

	        this._windowResizeHandler = _.bind(windowResizeHandler, this);

	        jQuery(window).on('resize', this._windowResizeHandler);
			
		},
	    bindings: {
	        
	    },

	    events: {
	    	'click [data-action="homepage-banner-click"]' : 'homeBannerClick',
	    	'touchstart [data-action="homepage-banner-click"]' : 'homeBannerTouchStart',
	    	'touchend [data-action="homepage-banner-click"]' : 'homeBannerTouchEnd'
		}


	    , 	childViews: {
			
		}

		, homeBannerTouchStart: function homeBannerTouchStart(e) {
			var touch = e.originalEvent.touches[0];
			this.touchStartX = touch.pageX;
			this.touchStartY = touch.pageY;
			this.touchStartTime = Date.now();
		}

		, homeBannerTouchEnd: function homeBannerTouchEnd(e) {
			if (!this.touchStartX) return;
			
			var touch = e.originalEvent.changedTouches[0];
			var deltaX = Math.abs(touch.pageX - this.touchStartX);
			var deltaY = Math.abs(touch.pageY - this.touchStartY);
			var deltaTime = Date.now() - this.touchStartTime;
			
			// If it was a tap (minimal movement, quick touch), trigger navigation
			if (deltaX < 10 && deltaY < 10 && deltaTime < 300) {
				e.preventDefault();
				e.stopPropagation();
				this.navigateBanner($(e.currentTarget));
			}
			
			this.touchStartX = null;
			this.touchStartY = null;
		}

		, homeBannerClick: function homeBannerClick(e)
		{
			e.preventDefault();
			e.stopPropagation();
			this.navigateBanner($(e.currentTarget));
		}

		, navigateBanner: function navigateBanner(ele)
		{
			var eleHashTag = ele.attr('data-element');

			var carouselItemsAppend = $('.home-carousel-append');
			carouselItemsAppend.html("<script>window.dataLayer = window.dataLayer || [];window.gtag('event', 'homepageproductbanner', {'url': '"+eleHashTag+"','page_location': '/' });</script>");

			// Navigate after analytics
			if(eleHashTag){
				Backbone.history.navigate(eleHashTag, {
					trigger: true
				});
			}
		}

		, getContext: function getContext()
		{
			

			var carousel_images = this.configuration.HomepageCarouselImages
			,   carousel_images_list = carousel_images.config

			//console.log(carousel_images_list)
			//console.log(carousel_images)
			/*var profile = ProfileModel.getInstance()
			,   is_loading = !Configuration.get('performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
            ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
           	
           	var mywindowWidth = jQuery(window).width();*/

	        return {
	           /* isLoggedIn : !is_loading && is_logged_in,
				isPhoneDevice: Utils.isPhoneDevice()*/
				carouselImages : carousel_images_list
	        };
		}
	});
});
